// list of allowed file formats (extensions) used by file uploader (file picker and drag'n'drop area)
export const allowedImages = ['jpg', 'jpeg', 'bmp', 'pdf',  'png', 'webp'];
export const allowedLivePreviewImages = ['jpg', 'jpeg', 'bmp', 'png', 'webp'];
export const allowedVideos = ['mp4', 'avi', 'mov', 'gif'];